import {loadScript} from "../load-script.function";

export class InstagramTokenLoaderClass {
  private readonly tokenJsonUrl = 'https://ig.instant-tokens.com/users/b0420fba-ed6a-47d9-81b4-7ef1ff330b11/instagram/9774868342540346/token?userSecret=fcwnh2kyu6c19vgmpad3k';
  private readonly instafeedUrl = '/vendor/instafeed.min.js';

  constructor() {
  }

  public init (): Promise<any> {
    return new Promise(((resolve, reject) => {
      loadScript(this.instafeedUrl, () => {
        const request = new XMLHttpRequest();
        request.open('GET', this.tokenJsonUrl, true);
        request.onload = _ => {
          if (request.status >= 200 && request.status < 400) {
            // Success!
            const data = JSON.parse(request.responseText);
            this.initFeed(data.Token, resolve);
          }
        };
        request.onerror = _ => {
          reject();
        };
        request.send();
      });
    }));
  }

  private initFeed (token: string, resolve: any): void {
    const feed = new Instafeed({
      accessToken: token,
      limit: 3,
      template: `
        <div class="instagram-feed__item hover-img-zoom"> 
          <a href="{{link}}" target="_blank"> 
            <figure> 
              <img class="hover-img-zoom__elem" loading="lazy" src="{{image}}" alt="{{caption}}">
              <figcaption class="sr-only">{{caption}}</figcaption>
            </figure> 
           </a>
         </div>
        `,
      after: () => {
        document.querySelector('.js-instagram-loader').remove();
        resolve();
      },
    });

    feed.run();
  }
}
